import axios from 'axios';

var menuUrl = 'http://localhost/Events/GetMenu/';
var eventsUrl = 'http://localhost/Events/GetEvents/';
var eventUrl = 'http://localhost/Events/GetEvent/';
var resultsUrl = 'http://localhost/Events/GetResults/';
var resultEventUrl = 'http://localhost/Events/GetResultEvent/';
var currentServerTimeUrl = 'http://localhost/Events/getCurrentServerTime/';

export default {
    GetMenu(updated, callback) {
        var data = new FormData();
        data.append('updated', updated);

        axios.post(menuUrl, data)
        .then((response) => {
            callback(response.data);
        })
        .catch((err) => {
            var output = {
                status: 0,
                result: {
                    error: ''
                }
            };

            if(!err.response) {
                console.error(err);
                output.result.error = 'Error: Network Error';
            } else {
                output.result.error = err.data.errors[0];
            }

            callback(output);
        });
    },
    GetEvents(events, onlyIDs = false, useUpdated = true, callback) {
        var data = new FormData();
        data.append('events', JSON.stringify(events));
        data.append('onlyIDs', onlyIDs);
        data.append('useUpdated', useUpdated);

        axios.post(eventsUrl, data)
        .then((response) => {
            callback(response.data);
        })
        .catch((err) => {
            var output = {
                status: 0,
                result: {
                    error: ''
                }
            };

            if(!err.response) {
                console.error(err);
                output.result.error = 'Error: Network Error';
            } else {
                output.result.error = err.data.errors[0];
            }

            callback(output);
        });
    },
    GetEvent(ID, updated, callback) {
        var data = new FormData();
        data.append('ID', ID);
        data.append('updated', updated);

        axios.post(eventUrl, data)
        .then((response) => {
            callback(response.data);
        })
        .catch((err) => {
            var output = {
                status: 0,
                result: {
                    error: ''
                }
            };

            if(!err.response) {
                console.error(err);
                output.result.error = 'Error: Network Error';
            } else {
                output.result.error = err.data.errors[0];
            }

            callback(output);
        });
    },
    GetResults(date, cacheDate, category, onlyIDs = false, callback) {
        var data = new FormData();
        data.append('date', date);
        data.append('cacheDate', cacheDate);
        data.append('category', category);
        data.append('onlyIDs', onlyIDs);

        axios.post(resultsUrl, data)
        .then((response) => {
            callback(response.data);
        })
        .catch((err) => {
            var output = {
                status: 0,
                result: {
                    errors: []
                }
            };

            if(!err.response) {
                console.error(err);
                output.result.errors = ['Error: Network Error'];
            } else {
                output.result.errors = err.data.errors;
            }

            callback(output);
        });
    },
    GetResultEvent(date, cacheDate, category, eventID, callback) {
        var data = new FormData();
        data.append('date', date);
        data.append('cacheDate', cacheDate);
        data.append('category', category);
        data.append('ID', eventID);

        axios.post(resultEventUrl, data)
        .then((response) => {
            callback(response.data);
        })
        .catch((err) => {
            var output = {
                status: 0,
                result: {
                    errors: []
                }
            };

            if(!err.response) {
                console.error(err);
                output.result.errors = ['Error: Network Error'];
            } else {
                output.result.errors = err.data.errors;
            }

            callback(output);
        });
    },
    GetCurrentServerTime(callback) {
        axios.get(currentServerTimeUrl)
        .then((response) => {
            callback(response.data);
        })
        .catch((err) => {
            var output = {
                status: 0,
                result: {
                    errors: []
                }
            };

            if(!err.response) {
                console.error(err);
                output.result.erors = ['Error: Network Error'];
            } else {
                output.result.errors = err.data.errors;
            }

            callback(output);
        })
    }
}


// WEBPACK FOOTER //
// ./src/API.js